<template>
    <div style="min-height: 200px;" v-loading="loading" element-loading-text="查询中..." v-cloak>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="平台分类" name="first"></el-tab-pane>
            <el-tab-pane label="自有分类" name="second"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName == 'first'">
            <el-input v-if="enableSearch != null && enableSearch == true" class="mt5 mb10" placeholder="输入关键字进行过滤" v-model="filterText">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="handleFilterTextClick"></i>
            </el-input>
            <el-tree ref="categTree" :data="dataList" :load="loadNode" lazy="" node-key="id" :key="flags" :filter-node-method="filterNode" :highlight-current="highlightCurrent" :props="defaultProps" :render-content="renderContent" :default-expanded-keys="defaultExpandedKeys"></el-tree>
        </div>
        <div v-else-if="activeName == 'second'">
            <swb-devc-cat-rel-list-for-select :checkBox="true" :selectGoodsCatIds="defaultCheckedItems" ref="swb_devc_cat_rel_list_for_select"></swb-devc-cat-rel-list-for-select>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, filterByName, Routes } from '../../app.vues'

import goodsCategApi from '../../api/goodsCateg'
import userApi from '../../api/user'

import SwbDevcCatListRelForSelect from './DevcCatListRelForSelect';

Vue.regist(SwbDevcCatListRelForSelect);

export default {
    name: 'swb-categ-and-devcCat-tree-multi-select',
    desc: '商品分类树列表 - 多选(支持三级，现在最少最后一级可被选择，可自定义第一级和第二级)',
    props: {
        enableSearch: {
            type: Boolean,
            default: true
        },
        noPostFilters: { // 是否不要进行岗位权限过滤
            type: Boolean,
            deafult: false,
        },
        showCheckboxLevel1: { // 第一级节点是否可被选择，默认否
            type: Boolean,
            default: false
        },
        showCheckboxLevel2: { // 第二级节点是否可被选择，默认否
            type: Boolean,
            default: false
        },
        checkStrictly: { //TODO 在显示复选框的情况下，是否严格的遵循父子不互相关联的做法，默认为 false，相互关联只支持下级节点禁用
            type: Boolean,
            deafult: false,
        },
        defaultCheckedItems: {// 回显的数据ids
            type: Array,
            default: function () {
                return [];
            }
        },
        model: { // 数据模型
            type: Object,
            default: function () {
                let model = {};
                model.catIdColumn = 'catId'; //
                model.catLevelColumn = 'catLevel';
                model.catNameColumn = 'catName';
                return model;
            }
        }
    },
    watch: {},
    data: function () {
        return {
            loading: false,
            highlightCurrent: true,
            filterText: '',
            dataList: [],
            defaultProps: {
                children: 'goodsCatSons',
                label: 'name'
            },
            defaultExpandedKeys: [],
            defaultExpandedKeysImpl: [],
            defaultExpandedKeysTo: [],
            checkCatIds: [],
            checkCatList: [],
            showDesc: false,
            isLoadNodeImpl: true,
            isLoadNode: true,
            initCatList: [],
            initLazyCatListImpl: [],
            initLazyCatList: [],
            activeName: 'first',
            flags: ''
        }
    },
    created: function () {
        //
        let model = this.model;
        //
        let defaultCheckedItems = this.defaultCheckedItems;
        //
        let catIds = defaultCheckedItems.pluck(model.catIdColumn);
        this.checkCatIds = catIds;
        this.checkCatList = defaultCheckedItems;
        //
        let catId1s = defaultCheckedItems.pluck(model.catIdColumn + 1);
        let catId2s = defaultCheckedItems.pluck(model.catIdColumn + 2);
        this.defaultExpandedKeysImpl = catId1s.concat(catId2s);
        this.defaultExpandedKeys = catId1s.concat(catId2s);
        this.defaultExpandedKeysTo = catId1s.concat(catId2s);
        //
        this.getGoodsCatTreeListByFilter();
        //
        let self = this;
        userApi.getUserInfoByContext({}, function (result) {
            if(result.type == 'info') {
                let merchantId = result.data.scopeEntity.id;
                // self.showDesc = merchantId == 259;
            } else {
                self.$message.error(result.message);
            }
        });
    },
    methods: {
        handleClick(tab, event) {
            let self = this;
            let filterText = this.filterText;
            if(!Utils.isNoB(filterText)) {
                this.filterText = null;
            }
            this.isLoadNodeImpl = true;
            this.dataList = Utils.merge([], this.initLazyCatList);
            this.defaultExpandedKeys = this.defaultExpandedKeysTo;
            this.getGoodsCatTreeListByFilter();
            self.flags = new Date().getTime();
        },
        handleFilterTextClick: function () {
            let filterText = this.filterText;
            if(Utils.isNoB(filterText)) {
                this.defaultExpandedKeys = [];
                this.isLoadNode = true;
                this.dataList = Utils.merge([], this.initLazyCatList);
            } else {
                this.isLoadNode = false;
                let initCatList = Utils.merge([], this.initCatList);
                let nodeKey = [];
                this.dataList = filterByName(initCatList, filterText, 'goodsCatSons', true, nodeKey, 'id');
                this.defaultExpandedKeys = Utils.merge([], nodeKey);
            }
        },
        getCategList() {
            let self = this;
            let postData = {};
            let filterItems = {};
            filterItems.noPostFilters = this.noPostFilters;
            postData.filterItems = filterItems;
            self.loading = true;
            goodsCategApi.getGoodsCatTreeList(postData, function (result) {
                if(result.type == 'info') {
                    let dataList = result.data;
                    //
                    self.mergeCheckCatList(dataList);
                    self.dataList = dataList;
                    self.initLazyCatList = dataList;
                } else {
                    self.$message.warning(result.message);
                }
                self.loading = false;
            });
        },
        getGoodsCatTreeListByFilter: function () {
            let self = this;
            let postData = {};
            postData.noPostFilters = this.noPostFilters;
            goodsCategApi.getGoodsCatTreeListByFilter(postData, function (result, jqXhr) {
                if(result.type == 'info') {
                    let data = result.data;
                    //
                    self.initCatList = data;
                } else {
                    self.$message.error(result.message);
                }
            });
        },
        mergeCheckCatList: function (dataList) {
            if(dataList != null && dataList.length > 0) {
                let checkCatIds = this.checkCatIds;
                let checkCatList = this.checkCatList;
                let model = this.model;
                //
                for(let i = 0; i < dataList.length; i++) {
                    let catInfo = dataList[i];
                    if(checkCatIds.contains(catInfo.id)) {
                        //
                        let item = checkCatList.find(function (elem, index) {
                            return elem[model.catIdColumn] == catInfo.id;
                        });
                        item[model.catNameColumn] = catInfo.name;
                    }
                }
            }
        },
        loadNodeImpl(node, resolve) {
            let self = this;
            let dbChildren = node.data.goodsCatSons || [];
            if(node.level === 0) {
                this.getCategList();
            } else {
                if(node.level >= 3) return resolve([]);
                let parentId = node.data.id;
                let postData = {};
                let filterItems = {};
                filterItems.parentId = parentId;
                filterItems.noPostFilters = this.noPostFilters;
                //
                if(this.isLoadNodeImpl == true) {
                    postData.filterItems = filterItems;
                    goodsCategApi.getImplGoodsCatTreeList(postData, function (result) {
                        if(result.type == 'info') {
                            self.mergeCheckCatList(result.data);
                            resolve(result.data);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                } else {
                    resolve(dbChildren);
                }
            }
        },
        loadNode(node, resolve) {
            let self = this;
            let dbChildren = node.data.goodsCatSons || [];
            if(node.level === 0) {
                this.getCategList();
            } else {
                if(node.level >= 3) return resolve([]);
                let parentId = node.data.id;
                let postData = {};
                let filterItems = {};
                filterItems.parentId = parentId;
                filterItems.noPostFilters = this.noPostFilters;
                postData.filterItems = filterItems;
                //
                if(this.isLoadNode == true) {
                    goodsCategApi.getGoodsCatTreeList(postData, function (result) {
                        if(result.type == 'info') {
                            self.mergeCheckCatList(result.data);
                            resolve(result.data);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                } else {
                    resolve(dbChildren);
                }
            }
        },
        filterNode(value, data) {
            if(!value) {
                return true;
            }
            return data.name.indexOf(value) !== -1;
        },
        renderContent: function (createElement, node) {
            //设置叶子节点标记（不然会出现多余的箭头）
            node.node.isLeaf = node.data.leafFlag;
            //
            let selfTree = this;
            return createElement({
                data: function () {
                    return {
                        item: node,
                        checkCatIds: selfTree.checkCatIds,
                        checkCatList: selfTree.checkCatList,
                        showCheckboxLevel1: selfTree.showCheckboxLevel1,
                        showCheckboxLevel2: selfTree.showCheckboxLevel2,
                        checkStrictly: selfTree.checkStrictly,
                        showDesc: selfTree.showDesc
                    };
                },
                template: '' +
                    '<span>' +
                    '<span v-if = "item.data.level == 1">' +
                    '<el-checkbox v-if = "showCheckboxLevel1" :checked = "checkCatIds.indexOf(item.data.id) >= 0" @change ="handleCheckedChange(item.data)" :label="item.data.id">{{item.data.name}}<span class="font-gray2" v-if="showDesc && item.data.desc != null">&nbsp;({{item.data.desc}})</span></el-checkbox>' +
                    '<span v-else>{{item.data.name}}<span class="font-gray2" v-if="showDesc && item.data.desc != null">&nbsp;({{item.data.desc}})</span></span>' +
                    '</span>' +
                    '<span v-if = "item.data.level == 2">' +
                    '<el-checkbox v-if = "showCheckboxLevel2" :disabled = "!checkStrictly && checkCatIds.indexOf(item.data.parentId) >= 0" :checked = "checkCatIds.indexOf(item.data.id) >= 0" :label="item.data.id" @change ="handleCheckedChange(item.data)">{{item.data.name}}<span class="font-gray2" v-if="showDesc && item.data.desc != null">&nbsp;({{item.data.desc}})</span></el-checkbox>' +
                    '<span v-else>{{item.data.name}}<span class="font-gray2" v-if="showDesc && item.data.desc != null">&nbsp;({{item.data.desc}})</span></span>' +
                    '</span>' +
                    '<el-checkbox v-else-if = "item.data.level == 3" :checked = "checkCatIds.indexOf(item.data.id) >= 0" :disabled = "!checkStrictly && (checkCatIds.indexOf(item.data.parentId) >= 0 || checkCatIds.indexOf(item.data.catId1) >= 0)" :label="item.data.id" @change ="handleCheckedChange(item.data)">{{item.data.name}}<span class="font-gray2" v-if="showDesc && item.data.desc != null">&nbsp;({{item.data.desc}})</span></el-checkbox>' +
                    '</span>',
                methods: {
                    handleCheckedChange: function (value) {
                        let model = selfTree.model;
                        //
                        let checkCatIds = selfTree.checkCatIds;
                        let checkCatList = selfTree.checkCatList;
                        //
                        if(checkCatIds.indexOf(value.id) >= 0) {
                            checkCatIds.remove(value.id);
                            //
                            let item = checkCatList.find(function (elem, index) {
                                return elem[model.catIdColumn] == value.id;
                            });
                            checkCatList.remove(item);
                        } else {
                            checkCatIds.push(value.id);
                            //
                            let item = {};
                            item[model.catIdColumn] = value.id;
                            item[model.catNameColumn] = value.name;
                            item[model.catLevelColumn] = value.level;
                            item[model.catIdColumn + 1] = value.catId1;
                            item[model.catIdColumn + 2] = value.catId2;
                            item[model.catIdColumn + 3] = value.catId3;
                            checkCatList.push(item);
                            // console.log(item);
                            // 删除下级选中
                            let checkStrictly = selfTree.checkStrictly;
                            if(!checkStrictly && value.level <= 2) {
                                for(let i = 0; i < checkCatList.length; i++) {
                                    let checkedCat = checkCatList[i];
                                    if(checkedCat[model.catIdColumn + value.level] == value.id && checkedCat[model.catIdColumn] != value.id) {
                                        checkCatIds.remove(checkedCat[model.catIdColumn]);
                                        checkCatList.splice(i, 1);
                                        i--;
                                    }
                                }
                            }
                        }
                    }
                }
            });
        },
        notityChange: function () {
            // 发生变化时向上传递
            this.$emit('notity-change', this.checkCatList);
        },
        getDlgResult() {
            let result = {};
            let checkCatList = this.checkCatList || [];
            let allCatIds = checkCatList.pluck('catId');
            //
            if(this.activeName == 'first') {
                if(checkCatList != null && checkCatList.length > 0) {
                    result.type = 'info';
                    result.data = checkCatList;
                } else {
                    result.type = 'warn';
                    result.message = '请选择分类';
                }
            } else {
                let resultDevcCat = this.$refs.swb_devc_cat_rel_list_for_select.getDlgResult() || {};
                if(resultDevcCat.type === 'info') {
                    let devcCatList = resultDevcCat.data || {};
                    //
                    let model = this.model;
                    for(let i = 0; i < devcCatList.length; i++) {
                        let devcCatInfo = devcCatList[i];
                        let item = {};
                        if(allCatIds.indexOf(devcCatInfo.goodsCatId) < 0) {
                            item[model.catIdColumn] = devcCatInfo.goodsCatId;
                            item[model.catNameColumn] = devcCatInfo.goodsCatName;
                            item[model.catLevelColumn] = devcCatInfo.goodsCatLevel;
                            checkCatList.push(item);
                        }
                    }
                    // 移除-掉自有分类取消勾选的
                    let checkedItemIds = devcCatList.pluck('goodsCatId');
                    let selIds = Utils.compareArrays(checkedItemIds, allCatIds)['less'];
                    for(let i = 0; i < checkCatList.length; i++) {
                        if(selIds.indexOf(checkCatList[i].catId) >= 0) {
                            checkCatList.splice(i, 1);
                        }
                    }
                    result.type = 'info';
                    result.data = checkCatList;
                } else {
                    result.type = 'warn';
                    result.message = resultDevcCat.message;
                }
            }
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/categ/CategAndDevcCatTreeMultiSelect.vue